import { AxiosRequestConfig } from 'axios';
import { merge } from 'lodash';

import { ReportType } from '@src/enums';
import { generateAuthHeaders } from '@src/factories';

import Client from './client';
import { EntityType, Result } from './types';

export type Data = {
  entityType: EntityType;
  id: string;
  reportType: ReportType;
  text: string;
};

type Response = {
  readonly result: Result;
  readonly status: number;
};

export default (
  data: Data,
  accessToken: string,
  config?: AxiosRequestConfig
) => {
  return Client.post<Response>(
    '/rs/v1/reports',
    data,
    merge(config, generateAuthHeaders(accessToken))
  );
};
